// import React, {useEffect, useState} from "react";
// import DivisionWiseProduct from "./DivisionWiseProduct";
// import LastBlog from "./LastBlog";
// import LastNews from "./LastNews";
// import useApi from "../../hooks/useApi";
// import {webInfo} from "../../utils/webInfo";
//
// export default function Home() {
//     const link = `${webInfo.baseUrl}/api/admin/dashboard`;
//     const {get,loading} = useApi()
//     const [data,setData] = useState<any>(null);
//     useEffect(() => {
//         const fetchAnalytics = async () => {
//             try {
//                 const res: any = await get(link);
//                 setData(res);
//             } catch (err) {
//                 console.error("Failed to fetch product", err);
//             }
//         };
//
//         fetchAnalytics();
//         // eslint-disable-next-line
//     }, []);
//
//     console.log(data)
//
//     return (
//         <div className="grid">
//             <div className="col-12 md:col-6 xl:col-3">
//                 <div className="card h-full">
//                     <span className="font-semibold text-lg">Divisions</span>
//                     <div className="flex justify-content-between align-items-start mt-3">
//                         <div className="w-6">
//                             <span className="text-4xl font-bold text-900">
//                                 07
//                             </span>
//                             <div className="text-green-500">
//                                 <span className="font-medium">+12%</span>
//                                 <i className="pi pi-arrow-up text-xs ml-2"></i>
//                             </div>
//                         </div>
//                         <div className="w-6">
//                             <svg
//                                 width="100%"
//                                 viewBox="0 0 258 96"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <path
//                                     d="M1 93.9506L4.5641 94.3162C8.12821 94.6817 15.2564 95.4128 22.3846 89.6451C29.5128 83.8774 36.641 71.6109 43.7692 64.4063C50.8974 57.2018 58.0256 55.0592 65.1538 58.9268C72.2821 62.7945 79.4103 72.6725 86.5385 73.5441C93.6667 74.4157 100.795 66.2809 107.923 65.9287C115.051 65.5765 122.179 73.0068 129.308 66.8232C136.436 60.6396 143.564 40.8422 150.692 27.9257C157.821 15.0093 164.949 8.97393 172.077 6.43766C179.205 3.9014 186.333 4.86425 193.462 12.0629C200.59 19.2616 207.718 32.696 214.846 31.0487C221.974 29.4014 229.103 12.6723 236.231 5.64525C243.359 -1.38178 250.487 1.29325 254.051 2.63076L257.615 3.96827"
//                                     style={{
//                                         strokeWidth: "2px",
//                                         stroke: "var(--primary-color)",
//                                     }}
//                                     stroke="10"
//                                 />
//                             </svg>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="col-12 md:col-6 xl:col-3">
//                 <div className="card h-full">
//                     <span className="font-semibold text-lg">Products</span>
//                     <div className="flex justify-content-between align-items-start mt-3">
//                         <div className="w-6">
//                             <span className="text-4xl font-bold text-900">
//                                 500+
//                             </span>
//                             <div className="text-green-500">
//                                 <span className="font-medium">+20%</span>
//                                 <i className="pi pi-arrow-up text-xs ml-2"></i>
//                             </div>
//                         </div>
//                         <div className="w-6">
//                             <svg
//                                 width="100%"
//                                 viewBox="0 0 115 41"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <path
//                                     d="M1 35.6498L2.24444 32.4319C3.48889 29.214 5.97778 22.7782 8.46667 20.3627C10.9556 17.9473 13.4444 19.5522 15.9333 21.7663C18.4222 23.9803 20.9111 26.8035 23.4 30.6606C25.8889 34.5176 28.3778 39.4085 30.8667 37.2137C33.3556 35.0189 35.8444 25.7383 38.3333 26.3765C40.8222 27.0146 43.3111 37.5714 45.8 38.9013C48.2889 40.2311 50.7778 32.3341 53.2667 31.692C55.7556 31.0499 58.2444 37.6628 60.7333 39.4617C63.2222 41.2607 65.7111 38.2458 68.2 34.9205C70.6889 31.5953 73.1778 27.9597 75.6667 23.5955C78.1556 19.2313 80.6444 14.1385 83.1333 13.8875C85.6222 13.6365 88.1111 18.2272 90.6 20.2425C93.0889 22.2578 95.5778 21.6977 98.0667 18.8159C100.556 15.9341 103.044 10.7306 105.533 7.37432C108.022 4.01806 110.511 2.50903 111.756 1.75451L113 1"
//                                     style={{
//                                         strokeWidth: "1px",
//                                         stroke: "var(--primary-color)",
//                                     }}
//                                 />
//                             </svg>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="col-12 md:col-6 xl:col-3">
//                 <div className="card h-full">
//                     <span className="font-semibold text-lg">Blogs & Events</span>
//                     <div className="flex justify-content-between align-items-start mt-3">
//                         <div className="w-6">
//                             <span className="text-4xl font-bold text-900">
//                                 08
//                             </span>
//                             <div className="text-pink-500">
//                                 <span className="font-medium">+24%</span>
//                                 <i className="pi pi-arrow-down text-xs ml-2"></i>
//                             </div>
//                         </div>
//                         <div className="w-6">
//                             <svg
//                                 width="100%"
//                                 viewBox="0 0 115 41"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <path
//                                     d="M1.5 1L2.74444 2.61495C3.98889 4.2299 6.47778 7.4598 8.96667 9.07151C11.4556 10.6832 13.9444 10.6767 16.4333 11.6127C18.9222 12.5487 21.4111 14.4271 23.9 16.6724C26.3889 18.9178 28.8778 21.5301 31.3667 20.1977C33.8556 18.8652 36.3444 13.5878 38.8333 11.3638C41.3222 9.13969 43.8111 9.96891 46.3 11.9894C48.7889 14.0099 51.2778 17.2217 53.7667 16.2045C56.2556 15.1873 58.7444 9.9412 61.2333 11.2783C63.7222 12.6155 66.2111 20.5359 68.7 21.4684C71.1889 22.401 73.6778 16.3458 76.1667 16.0009C78.6556 15.6561 81.1444 21.0217 83.6333 24.2684C86.1222 27.515 88.6111 28.6428 91.1 27.4369C93.5889 26.2311 96.0778 22.6916 98.5667 22.7117C101.056 22.7317 103.544 26.3112 106.033 29.7859C108.522 33.2605 111.011 36.6302 112.256 38.3151L113.5 40"
//                                     style={{
//                                         strokeWidth: "1px",
//                                         stroke: "var(--pink-500)",
//                                     }}
//                                 />
//                             </svg>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             <div className="col-12 md:col-6 xl:col-3">
//                 <div className="card h-full">
//                     <span className="font-semibold text-lg">Career</span>
//                     <div className="flex justify-content-between align-items-start mt-3">
//                         <div className="w-6">
//                             <span className="text-4xl font-bold text-900">
//                                 03
//                             </span>
//                             <div className="text-green-500">
//                                 <span className="font-medium">+30%</span>
//                                 <i className="pi pi-arrow-up text-xs ml-2"></i>
//                             </div>
//                         </div>
//                         <div className="w-6">
//                             <svg
//                                 width="100%"
//                                 viewBox="0 0 103 24"
//                                 fill="none"
//                                 xmlns="http://www.w3.org/2000/svg"
//                             >
//                                 <path
//                                     d="M0.5 22.7464L2 23C3.40972 23.1524 5.42201 18.0581 8.95833 16.9517C12 16 14.5972 23.4341 17.4167 20.4309C20.2361 17.4277 19 9.50002 25.5 9.50002C31 9.50002 30 4.00002 33 4.00002C35.8428 4.00002 40 13 42.7917 11.0655C47.3252 7.92391 48.4306 14.016 51.25 11.4384C54.0694 8.86075 56.5 12.5 59.7083 8.22399C63.3559 3.36252 65.4888 0.499985 68.5 0.499985C73 0.499985 73.5 7.00001 78.5 6.5C84.9677 5.85322 82.2931 2.58281 85 1.50002C87.5 0.500003 90.7222 11.8656 93.5417 8.93639C97.5 4.00002 99.1806 7.12226 100.59 7.6798L102 8.23734"
//                                     stroke="#6366F1"
//                                 />
//                             </svg>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//
//
//
//
//
//
//
//
//
//
//
//             <div className="col-12 xl:col-6">
//                 <DivisionWiseProduct data={data?.analytics}/>
//             </div>
//             <div className="col-12 xl:col-3">
//                 <LastNews/>
//             </div>
//             <div className="col-12 xl:col-3">
//                 <LastBlog/>
//             </div>
//
//         </div>
//     );
// }

import React, {useEffect, useState} from "react";
import DivisionWiseProduct from "./DivisionWiseProduct";
import LastBlog from "./LastBlog";
import LastNews from "./LastNews";
import useApi from "../../hooks/useApi";
import {webInfo} from "../../utils/webInfo";
import {Skeleton} from "primereact/skeleton";
import DivisionWiseCategory from "./DivisionWiseCategory";

export default function Home() {
    const link = `${webInfo.baseUrl}/api/admin/dashboard`;
    const { get, loading } = useApi();
    const [data, setData] = useState<any>(null);

    useEffect(() => {
        const fetchAnalytics = async () => {
            try {
                const res: any = await get(link);
                setData(res);
            } catch (err) {
                console.error("Failed to fetch dashboard data", err);
            }
        };

        fetchAnalytics();
        // eslint-disable-next-line
    }, []);

    const divisionCount = data?.analytics ? Object.keys(data.analytics).length : 0;
    const totalProducts = data?.analytics
        ? Object.values(data.analytics).reduce((sum: number, item: any) => sum + Number(item || 0), 0)
        : 0;

    if (loading){
        return <div className="grid">
            <div className="col-12 md:col-9">
                <div className="grid">
                    {
                        Array.from({length:8}).map((_, i) => {
                            return <div key={i} className="col-12 md:col-6 xl:col-3">
                                <Skeleton className="w-full" height="11rem"></Skeleton>
                            </div>
                        })
                    }
                </div>
            </div>
            <div className="col-12 md:col-3">
                <Skeleton className="w-full" height="23rem"></Skeleton>
            </div>
            <div className="col-12 md:col-6 xl:col-6">
                <Skeleton className="w-full" height="38rem"></Skeleton>
            </div>
            <div className="col-12 md:col-6 xl:col-3">
                <Skeleton className="w-full" height="38rem"></Skeleton>
            </div>
            <div className="col-12 md:col-6 xl:col-3">
                <Skeleton className="w-full" height="38rem"></Skeleton>
            </div>
        </div>
    }


    return (
        <div className="grid">
            <div className="col-12 md:col-6 xl:col-9">
                <div className="grid">
                    <div className="col-12 md:col-6 xl:col-4">
                        <div className="card h-full">
                            <span className="font-semibold text-lg">Divisions</span>
                            <div className="flex justify-content-between align-items-start mt-3">
                                <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                {loading ? "..." : String(divisionCount).padStart(2, "0")}
                            </span>
                                </div>
                                <div className="w-6">
                                    <svg
                                        width="100%"
                                        viewBox="0 0 258 96"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 93.9506L4.5641 94.3162C8.12821 94.6817 15.2564 95.4128 22.3846 89.6451C29.5128 83.8774 36.641 71.6109 43.7692 64.4063C50.8974 57.2018 58.0256 55.0592 65.1538 58.9268C72.2821 62.7945 79.4103 72.6725 86.5385 73.5441C93.6667 74.4157 100.795 66.2809 107.923 65.9287C115.051 65.5765 122.179 73.0068 129.308 66.8232C136.436 60.6396 143.564 40.8422 150.692 27.9257C157.821 15.0093 164.949 8.97393 172.077 6.43766C179.205 3.9014 186.333 4.86425 193.462 12.0629C200.59 19.2616 207.718 32.696 214.846 31.0487C221.974 29.4014 229.103 12.6723 236.231 5.64525C243.359 -1.38178 250.487 1.29325 254.051 2.63076L257.615 3.96827"
                                            style={{
                                                strokeWidth: "2px",
                                                stroke: "var(--primary-color)",
                                            }}
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-6 xl:col-4">
                        <div className="card h-full">
                            <span className="font-semibold text-lg">Products</span>
                            <div className="flex justify-content-between align-items-start mt-3">
                                <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                {loading ? "..." : totalProducts}
                            </span>
                                </div>
                                <div className="w-6">
                                    <svg
                                        width="100%"
                                        viewBox="0 0 115 41"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1 35.6498L2.24444 32.4319C3.48889 29.214 5.97778 22.7782 8.46667 20.3627C10.9556 17.9473 13.4444 19.5522 15.9333 21.7663C18.4222 23.9803 20.9111 26.8035 23.4 30.6606C25.8889 34.5176 28.3778 39.4085 30.8667 37.2137C33.3556 35.0189 35.8444 25.7383 38.3333 26.3765C40.8222 27.0146 43.3111 37.5714 45.8 38.9013C48.2889 40.2311 50.7778 32.3341 53.2667 31.692C55.7556 31.0499 58.2444 37.6628 60.7333 39.4617C63.2222 41.2607 65.7111 38.2458 68.2 34.9205C70.6889 31.5953 73.1778 27.9597 75.6667 23.5955C78.1556 19.2313 80.6444 14.1385 83.1333 13.8875C85.6222 13.6365 88.1111 18.2272 90.6 20.2425C93.0889 22.2578 95.5778 21.6977 98.0667 18.8159C100.556 15.9341 103.044 10.7306 105.533 7.37432C108.022 4.01806 110.511 2.50903 111.756 1.75451L113 1"
                                            style={{
                                                strokeWidth: "1px",
                                                stroke: "var(--primary-color)",
                                            }}
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-6 xl:col-4">
                        <div className="card h-full">
                            <span className="font-semibold text-lg">Blogs</span>
                            <div className="flex justify-content-between align-items-start mt-3">
                                <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                {loading ? "..." : String(data?.blog_count).padStart(2, "0")}
                            </span>
                                </div>
                                <div className="w-6">
                                    <svg
                                        width="100%"
                                        viewBox="0 0 115 41"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M1.5 1L2.74444 2.61495C3.98889 4.2299 6.47778 7.4598 8.96667 9.07151C11.4556 10.6832 13.9444 10.6767 16.4333 11.6127C18.9222 12.5487 21.4111 14.4271 23.9 16.6724C26.3889 18.9178 28.8778 21.5301 31.3667 20.1977C33.8556 18.8652 36.3444 13.5878 38.8333 11.3638C41.3222 9.13969 43.8111 9.96891 46.3 11.9894C48.7889 14.0099 51.2778 17.2217 53.7667 16.2045C56.2556 15.1873 58.7444 9.9412 61.2333 11.2783C63.7222 12.6155 66.2111 20.5359 68.7 21.4684C71.1889 22.401 73.6778 16.3458 76.1667 16.0009C78.6556 15.6561 81.1444 21.0217 83.6333 24.2684C86.1222 27.515 88.6111 28.6428 91.1 27.4369C93.5889 26.2311 96.0778 22.6916 98.5667 22.7117C101.056 22.7317 103.544 26.3112 106.033 29.7859C108.522 33.2605 111.011 36.6302 112.256 38.3151L113.5 40"
                                            style={{
                                                strokeWidth: "1px",
                                                stroke: "var(--pink-500)",
                                            }}
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-6 xl:col-4">
                        <div className="card h-full">
                            <span className="font-semibold text-lg">News Event</span>
                            <div className="flex justify-content-between align-items-start mt-3">
                                <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                {loading ? "..." : String(data?.news_event_count).padStart(2, "0")}
                            </span>
                                </div>
                                <div className="w-6">
                                    <svg
                                        width="100%"
                                        viewBox="0 0 103 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.5 22.7464L2 23C3.40972 23.1524 5.42201 18.0581 8.95833 16.9517C12 16 14.5972 23.4341 17.4167 20.4309C20.2361 17.4277 19 9.50002 25.5 9.50002C31 9.50002 30 4.00002 33 4.00002C35.8428 4.00002 40 13 42.7917 11.0655C47.3252 7.92391 48.4306 14.016 51.25 11.4384C54.0694 8.86075 56.5 12.5 59.7083 8.22399C63.3559 3.36252 65.4888 0.499985 68.5 0.499985C73 0.499985 73.5 7.00001 78.5 6.5C84.9677 5.85322 82.2931 2.58281 85 1.50002C87.5 0.500003 90.7222 11.8656 93.5417 8.93639C97.5 4.00002 99.1806 7.12226 100.59 7.6798L102 8.23734"
                                            stroke="#6366F1"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-6 xl:col-4">
                        <div className="card h-full">
                            <span className="font-semibold text-lg">Career</span>
                            <div className="flex justify-content-between align-items-start mt-3">
                                <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                {loading ? "..." : String(data?.career_count).padStart(2, "0")}
                            </span>
                                </div>
                                <div className="w-6">
                                    <svg
                                        width="100%"
                                        viewBox="0 0 103 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.5 22.7464L2 23C3.40972 23.1524 5.42201 18.0581 8.95833 16.9517C12 16 14.5972 23.4341 17.4167 20.4309C20.2361 17.4277 19 9.50002 25.5 9.50002C31 9.50002 30 4.00002 33 4.00002C35.8428 4.00002 40 13 42.7917 11.0655C47.3252 7.92391 48.4306 14.016 51.25 11.4384C54.0694 8.86075 56.5 12.5 59.7083 8.22399C63.3559 3.36252 65.4888 0.499985 68.5 0.499985C73 0.499985 73.5 7.00001 78.5 6.5C84.9677 5.85322 82.2931 2.58281 85 1.50002C87.5 0.500003 90.7222 11.8656 93.5417 8.93639C97.5 4.00002 99.1806 7.12226 100.59 7.6798L102 8.23734"
                                            stroke="#6366F1"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 md:col-6 xl:col-4">
                        <div className="card h-full">
                            <span className="font-semibold text-lg">Notice</span>
                            <div className="flex justify-content-between align-items-start mt-3">
                                <div className="w-6">
                            <span className="text-4xl font-bold text-900">
                                {loading ? "..." : String(data?.notice_board_count).padStart(2, "0")}
                            </span>
                                </div>
                                <div className="w-6">
                                    <svg
                                        width="100%"
                                        viewBox="0 0 103 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M0.5 22.7464L2 23C3.40972 23.1524 5.42201 18.0581 8.95833 16.9517C12 16 14.5972 23.4341 17.4167 20.4309C20.2361 17.4277 19 9.50002 25.5 9.50002C31 9.50002 30 4.00002 33 4.00002C35.8428 4.00002 40 13 42.7917 11.0655C47.3252 7.92391 48.4306 14.016 51.25 11.4384C54.0694 8.86075 56.5 12.5 59.7083 8.22399C63.3559 3.36252 65.4888 0.499985 68.5 0.499985C73 0.499985 73.5 7.00001 78.5 6.5C84.9677 5.85322 82.2931 2.58281 85 1.50002C87.5 0.500003 90.7222 11.8656 93.5417 8.93639C97.5 4.00002 99.1806 7.12226 100.59 7.6798L102 8.23734"
                                            stroke="#6366F1"
                                        />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12 md:col-6 xl:col-3">
                <DivisionWiseCategory data={data?.category_count}/>
            </div>

            <div className="col-12 xl:col-6">
                <DivisionWiseProduct data={data?.analytics} />
            </div>

            <div className="col-12 xl:col-3">
                <LastNews data={data?.recent_blogs || []} loading={loading} />
            </div>

            <div className="col-12 xl:col-3">
                <LastBlog data={data?.recent_careers || []} loading={loading} />
            </div>
        </div>
    );
}
